import { render, staticRenderFns } from "./BoAddService.vue?vue&type=template&id=567bf58c&"
import script from "./BoAddService.vue?vue&type=script&lang=js&"
export * from "./BoAddService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports